export default {"src":"/_next/static/media/icon-avionics.d04a1111.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};